import { useDispatch, useSelector } from "react-redux";

import useLogout from "./useLogout";
import { RootState } from "../redux/store";
import AuthService from "../services/auth.service";
import { refreshTokenSuccess } from "../redux/auth/authSlice";

const useTokenRefresh = () => {
  const dispatch = useDispatch();
  const handleLogout = useLogout();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  const handleSignout = async () => {
    await handleLogout();
  };

  const refresh = async () => {
    if (!isAuthenticated) {
      return true;
    }

    try {
      const response = await AuthService.refreshToken();

      dispatch(refreshTokenSuccess({ accessToken: response.accessToken }));

      return true;
    } catch (error) {
      console.error("useTokenRefresh: Refresh failed:", error);
      handleSignout();

      return false;
    }
  };

  return refresh;
};

export default useTokenRefresh;
